module.exports = __webpack_public_path__ + "21db5090d0374e17a2926a87e0742e12.svg";